<template>
	<div class="text-base text-black tracking-normal leading-tight relative font-normal font-sans" style="z-index:10000;">
		<transition name="fade" appear>
			<div class="fixed top-0 left-0 h-screen w-full flex justify-center items-center p-4" v-if="visible">
				<div @click="close" class="absolute top-0 left-0 w-full h-full bg-black opacity-75"></div>
				<div class="max-w-xs relative w-full shadow bg-white p-1 flex flex-col justify-around sm:max-w-sm md:max-w-md md:p-2">
					<div class="absolute top-0 right-0 m-2 cursor-pointer text-black" @click="close">
						<div class="absolute bg-white rounded-lg inset-0 opacity-50 m-1"></div>
						<div class="relative z-10 p-1">
							<svg class="h-6 w-6" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
						</div>
					</div>

					<div class="bg-primary-500 text-white overflow-hidden">
						<img class="w-full h-auto" :src="require('@/assets/img/Header.jpg')">
						<div class="px-2 py-4 sm:px-4">
							<h2 class="text-3xl leading-none text-center sm:text-4xl"><span class="font-bold">FREE</span> Wally Receiver</h2>
							<p class="text-center text-lg sm:text-base md:text-lg">with purchase of any satellite antenna bundle!</p>
							
							<div class="bg-white h-px w-full mt-2 sm:mt-4"></div>

							<div class="flex flex-col items-center text-center text-2xl mt-2 leading-tight sm:text-left sm:items-start sm:mt-4">
								<p class="inline sm:leading-none md:text-3xl">USE CODE: <span class="font-bold">KICKOFF</span>&nbsp;</p>
								<div class="flex items-end">
									<div class="flex-shrink-0 sm:pr-1">
										<p class="inline-block sm:text-xl md:text-2xl">At Checkout</p>
										<div class="flex justify-center sm:justify-start">
											<a @click.prevent="navigate" href="https://www.dishformytailgate.com/spotlight/?no-popup" class="bg-white text-primary-500 py-1 px-2 rounded-lg text-xl block font-bold mt-2 md:mt-6 md:text-2xl">Shop Now</a>
										</div>
									</div>
									<div class="hidden flex-shrink-1 ml-4 sm:block md:-mr-20">
										<img class="w-full max-w-sm" :src="require('@/assets/img/Wally.png')">
									</div>
								</div>
							</div>

							<p class="text-xs mt-4 text-center">Must add both antenna and Wally to your cart</p>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		created() {
			if (window.location.href.includes('?no-popup')) {
				this.close()
				if (window.history.pushState) {
					window.history.pushState({
						path: window.location.href.split('?')[0]
					})
				}

				return
			}
		},
		
		data() {
			return {
				visible: true,
			}
		},

		methods: {
			close() {
				this.visible = false

				const iframe = document.createElement('iframe')
				iframe.src = 'https://popup.dishformytailgate.com/loader.html?close'
				iframe.setAttribute('style', 'display:none!important;')

				document.body.appendChild(iframe)
			},

			navigate() {
				const iframe = document.createElement('iframe')
				iframe.src = 'https://popup.dishformytailgate.com/loader.html?close'
				iframe.setAttribute('style', 'display:none!important;')
				iframe.addEventListener('load', () => {
					window.location.href = 'https://www.dishformytailgate.com/spotlight/'
				})

				document.body.appendChild(iframe)
			}
		},
	}
</script>

<style scoped src="@/assets/css/tailwind.css"/>

<style scoped>
	.fade-enter-active {
		transition: opacity 1s;
	}

	.fade-leave-active {
		transition: opacity .25s;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
</style>

<style>
	@tailwind base;

	html {
		font-size: 16px!important;
	}
	
	@font-face {
		font-family: proxima-nova;
		font-style: normal;
		font-weight: 400;
		font-display: swap;
		src: url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-b178c0c2d00114bb5e2c276d4489695cccdd6967.woff2") format("woff2"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-98924b01af01a04387040ef9cf83f5b6fd26c117.woff") format("woff"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-cf06fe4c3be8f30d33fa79b3d6770be5ff6db287") format("opentype");
	}

	@font-face {
		font-family: proxima-nova;
		font-style: normal;
		font-weight: 500;
		font-display: swap;
		src: url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-092a0e4e3cd74c81dc0c1dde2cbc5ec222143003.woff2") format("woff2"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-e302e89422ca9627c947dfb25e49c22a7466ba0d.woff") format("woff"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-c9e8172cc6ff501e682d3c95665e1b30a7ea4871") format("opentype");
	}

	@font-face {
		font-family: proxima-nova;
		font-style: normal;
		font-weight: 600;
		font-display: swap;
		src: url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-c0daba7ca572b4d82baf19c71e2a07d650e35647.woff2") format("woff2"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-ff50f54e4d4f6b4954ef00861381eb2a52752692.woff") format("woff"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-34f47b537d9f72758cdfc589225ce55fc97c897e") format("opentype");
	}

	@font-face {
		font-family: proxima-nova;
		font-style: normal;
		font-weight: 700;
		font-display: swap;
		src: url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-361ed78bf309b06305b4ed718f9b027160bd4ee8.woff2") format("woff2"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-a9f5393402174551a2ff00c9c20739b82e138c53.woff") format("woff"), 
			url("https://cdn2.hubspot.net/hubfs/1846077/fonts/proximanova/proximanova-a293e8efa42c475fc6c36390e8f12aba257e5e29") format("opentype");
	}
</style>
